import styles from './Paytm.module.scss';
import { useContext } from 'react';
import OverviewContext from 'store/overview-context';
const Paytm = () => {
	const { overviewData, createObj } = useContext(OverviewContext);

	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	return (
		<div className={styles.container}>
			<iframe title='Paytm' src={`${process.env.REACT_APP_BASE_URL}/payments/v1/paytm/initiateTransaction?c_id=${overviewData.c_id}&bd_token=${overviewData.bd_token}&ts_paymentTimezone=${timezone}&ts_amount=${createObj?.ts_amount}`}></iframe>
		</div>
	);
};

export default Paytm;
